"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkActionsToolbar = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const bulk_actions_toolbar_styles_1 = require("./bulk-actions-toolbar.styles");
const localization_1 = require("../../../localization");
const BulkActionsToolbar = ({ total = 0, selectedCount = 0, onBulkCommentActionClick, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(bulk_actions_toolbar_styles_1.StyledBulkActionsContainer, null, react_1.default.createElement(ui_components_1.Typography, { strong: true, variant: "caption" }, t({ key: 'NUMBER_SELECTED', values: { count: selectedCount, total } })), react_1.default.createElement(ui_components_1.Typography, { variant: "subtitle2", strong: true }, t({ key: 'BULK_ACTIONS' })), react_1.default.createElement(bulk_actions_toolbar_styles_1.StyledBulkAction, { rounded: true, size: "small", variant: "contained", color: "primary", title: t({ key: 'COMMENT' }), onClick: onBulkCommentActionClick })));
};
exports.BulkActionsToolbar = BulkActionsToolbar;
exports.default = exports.BulkActionsToolbar;
